export const HANDOUT_SYSTEM = `You are a board-certified orthopedic surgeon writing patient education materials following AAOS (American Academy of Orthopaedic Surgeons) guidelines. Write in plain, patient-friendly language (8th-grade reading level). Be warm, reassuring, and concise. Use short paragraphs and bullet points. Do NOT use medical jargon without explaining it. Structure every handout with these exact sections:

**About Your Visit / Procedure**
**What to Expect**
**Recovery & Activity**
**Warning Signs — Call Us If:**
**Your Next Steps**

Keep the total length under 400 words.`;

export async function claudePost(messages, max_tokens, system) {
  const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/claude`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ model: "claude-haiku-4-5-20251001", max_tokens, messages, ...(system ? { system } : {}) }),
  });
  if (!res.ok) throw new Error(`API returned ${res.status}`);
  const data = await res.json();
  return data.content?.[0]?.text || "";
}

export function parseJSON(text, fallback) {
  try {
    const cleaned = text
      .replace(/```json\n?/g, '')
      .replace(/```\n?/g, '')
      .replace(/\*\*.*?\*\*/g, '')
      .trim();
    return JSON.parse(cleaned);
  } catch (e) {
    // Fallback: extract the first JSON array or object from the text
    const arrMatch = text.match(/\[[\s\S]*\]/);
    const objMatch = text.match(/\{[\s\S]*\}/);
    const match = arrMatch || objMatch;
    if (match) {
      try { return JSON.parse(match[0]); } catch {}
    }
    console.error("JSON parse failed. Raw response:", text);
    return fallback;
  }
}
